<template>
  <div>
    <div class="">
      <!-- <img style="width:100%;height:50vh" :src="detailDatda.thumb" /> -->
      <img style="width:100%;height:26vh" src="static/assets/images/shouye_bg.png" />

      <div class="row">
        <div class="col-lg-12 detail_title">
          <h3>{{ detailDatda.title }}</h3>
        </div>
      </div>
      <div class="row">
        <div class="col-lg-12 detail_brief">
          <div v-if="detailDatda.content != null" v-html="detailDatda.content"></div>
          <div v-else>
            <el-empty description="暂无数据"></el-empty>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { detail } from '@/api/index'
import axios from "axios";

export default {
  data() {
    return {
      detailDatda: {}
    }
  },
  watch: {
    $route: {
      handler: function (val, oldVal) {
        this.getContent(val.query);
      }
    },
  },
  mounted() {
    this.getContent(this.$route.query);
  },
  methods: {
    getContent(params) {
      if (!!params.source) {
        if (params.source === "article") {
          this.getArticleId(params.id);
        } else {
          this.getDetail(params.id);
        }
      } else {
        this.getDetail(params.id);
      }
    },
    getDetail(id) {
      axios.get('http://cms.saveus.cn/api/ttg/detail?id=' + id).then(res => {
        this.detailDatda = res.data.data
      })
    },
    getArticleId(id) {
      axios.get('http://cms.saveus.cn/api/ttg/page?id=' + id).then(res => {
        let list = res.data.data;
        if (list.length > 0) {
          axios.get('http://cms.saveus.cn/api/ttg/detail?id=' + list[0].id).then(res => {
            this.detailDatda = res.data.data
          })
        } else {
          this.detailDatda = {};
        }
      })
    },
  },
}
</script>
<style scoped>
  .detail_brief /deep/ img {
    display: none;
  }

@media (min-width: 280px) and (max-width: 768px) {
  .container,.row {
    padding-right: 0px;
    padding-left: 0px;
    margin-right: 0px;
    margin-left: 0px;
  }
}

.detail_title {
  text-align: center;
  padding: 1vh 0;
}

@media (min-width: 1200px) {
  .row {
    padding-right: 0px;
    padding-left: 0px;
    margin-right: 0px;
    margin-left: 0px;
  }

  .detail_title {
    text-align: center;
    padding: 1vh 0;
  }

  .detail_brief {
    min-height: 45vh;
    width: 50%;
    padding: 0 1vh;
  }

  .detail_brief>div {
    padding: 1vh;
    font-size: 2vh;
    width: 90%;
    margin: 0 auto;
    border-radius: 10px;
  }
}
</style>



// WEBPACK FOOTER //
// detail.vue?1f83765e